<template>
	<div class="cont-main">
		<div>
			<el-row>
				<el-col :span="4">目标文件夹</el-col>
				<el-col :span="12"><el-input type="text" v-model="copypath" placeholder="默认当前文件夹,其他文件夹请输入相对路径"></el-input></el-col>
			</el-row>
			<el-row>
				<el-col :span="4">目标文件</el-col>
				<el-col :span="12"><el-input type="text" v-model="copyname" placeholder="请输入目标文件名,如果文件存在内容将会被覆盖"></el-input></el-col>
			</el-row>
		</div>
		<div class="text-left mirror-container"><codemirror v-model="content" :options="options"></codemirror></div>
		<div class="text-center operate">
			<el-button type="primary" @click="copyFile">确认复制</el-button>
			<el-button type="warning" @click="turnBack()">取消复制</el-button>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { codemirror } from 'vue-codemirror';
// 核心样式
import 'codemirror/lib/codemirror.css';
// 引入主题后还需要在 options 中指定主题才会生效
import 'codemirror/theme/panda-syntax.css';
import 'codemirror/mode/python/python.js';
export default {
	name: '',
	components: {
		codemirror
	},
	data() {
		return {
			filepath: '',
			filename: '',
			content: '', // 编辑器绑定的值
			// 默认配置
			options: {
				tabSize: 2, // 缩进格式
				theme: 'panda-syntax', // 主题，对应主题库 JS 需要提前引入
				lineNumbers: true, // 显示行号
				line: true,
				styleActiveLine: true, // 高亮选中行
				hintOptions: {
					completeSingle: true // 当匹配只有一项的时候是否自动补全
				}
			},
			copypath: '',
			copyname: ''
		};
	},
	mounted() {
		this.filepath = this.$route.query.filepath;
		this.filename = this.$route.query.filename;
		this.getFileContent();
	},
	methods: {
		...mapMutations({
			setPageRefresh: 'auth/setPageRefresh'
		}),
		getFileContent() {
			this.$axios({
				url: this.HOST + '/admin.files/openFile',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					filepath: this.filepath + '/' + this.filename
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.content = res.data.info;
					}
				})
				.catch(err => {});
		},
		copyFile() {
			this.$axios({
				url: this.HOST + '/admin.files/copyFile',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					filepath: this.filepath,
					copypath: this.copypath,
					copyname: this.copyname,
					copycontent: this.content
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.setPageRefresh(true);
						this.turnBack();
					}
				})
				.catch(err => {});
		}
	}
};
</script>
<style lang="scss">
.cont-main {
	box-sizing: border-box;
	padding-left: 20px;
	overflow-x: hidden;
	.CodeMirror {
		height: 600px;
	}
	.operate {
		margin-top: 60px;
	}
}
</style>
